const LOCAL_REVIEW_HOSTS = new Set(['127.0.0.1', 'localhost', '::1']);

// Discord OAuth is registered to the production origin. A localhost start
// therefore returns the browser to production, which is the wrong destination
// for a local live-data review. Password auth is the supported same-origin
// path through the bound development proxy.
export function isLocalReviewHost(hostname: string): boolean {
  return LOCAL_REVIEW_HOSTS.has(hostname.toLowerCase());
}
